import React from "react";

const IconCard = ({ children }) => {
  return (
    <div className="bg-sport-yellow rounded-full p-4 w-max h-max mr-4">
      {children}
    </div>
  );
};

export default IconCard;
